import { createContext, useContext, useState } from 'react';

const ColourSettingContext = createContext(null);

export const useColourSettingContext = () => {
    return useContext(ColourSettingContext);
};

export const ColourSettingProvider = props => {
    const [colourSettings, setColourSettings] = useState('hsl');

    return (
        <ColourSettingContext.Provider value={[colourSettings, setColourSettings]}>
            {props.children}
        </ColourSettingContext.Provider>
    );
};
